import { Pipe, PipeTransform } from '@angular/core';
import { SimWithUsage, Sim } from '../models/sim';
import { SelectItem } from 'primeng/api/selectitem';

@Pipe({
  name: 'simUniqueValues'
})
export class SimUniqueValuesPipe implements PipeTransform {

  transform(sims: Sim[] | SimWithUsage[], field: string, subField?: string, ): SelectItem[] {
    return sims ? [...new Set(sims.filter((sim: Sim | SimWithUsage) => !!(subField ? sim[field][subField] :  sim[field]))
      .map((sim: Sim | SimWithUsage) => (subField ? sim[field][subField] :  sim[field])))
    ].filter(label => !!label).map(label => {
      return {
        label: label ? label.toString() : '',
        value: label
      }
    }) : [];
  }

}
